import React, { useState } from "react";
import { Loader2, Mail, Lock, Eye, EyeOff, ArrowLeft, CheckCircle, XCircle } from "lucide-react";

const PrimerLoginEmpleado = () => {
  const [form, setForm] = useState({ email: "", password: "", confirmPassword: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlert(null);
    if (!form.email || !form.password || !form.confirmPassword) {
      setAlert({ type: "error", message: "Completa todos los campos." });
      return;
    }
    if (form.password.length < 6) {
      setAlert({ type: "error", message: "La contraseña debe tener al menos 6 caracteres." });
      return;
    }
    if (form.password !== form.confirmPassword) {
      setAlert({ type: "error", message: "Las contraseñas no coinciden." });
      return;
    }
    setLoading(true);
    try {
      const response = await fetch("https://nokk-backend.vercel.app/api/primer-login-empleado", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: form.email, password: form.password })
      });
      const result = await response.json();
      if (result.success) {
        setAlert({ type: "success", message: result.message });
        setTimeout(() => { window.location.href = "/login"; }, 1800);
      } else {
        setAlert({ type: "error", message: result.error || "Error al crear contraseña." });
      }
    } catch (err) {
      setAlert({ type: "error", message: "Error de conexión." });
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: 'Inter, sans-serif',
      padding: "20px"
    }}>
      <div style={{
        background: "rgba(255,255,255,0.97)",
        borderRadius: "24px",
        padding: "32px 20px 24px 20px",
        maxWidth: "400px",
        width: "100%",
        boxShadow: "0 20px 60px -12px rgba(0,0,0,0.18)",
        border: "1px solid rgba(255,255,255,0.2)",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}>
        <div style={{ textAlign: "center", marginBottom: 24, width: "100%" }}>
          <img src="https://llohruvkcdcyolmwlivx.supabase.co/storage/v1/object/public/public-assets//logonokk.png" alt="NOKK" style={{ height: 28, opacity: 0.9, marginBottom: 8 }} />
          <h2 style={{ fontSize: 22, fontWeight: 700, color: "#0f172a", margin: 0 }}>Primer acceso empleado</h2>
          <p style={{ color: "#64748b", fontSize: 14, margin: "8px 0 0 0" }}>Crea tu contraseña para acceder a la plataforma</p>
        </div>
        {alert && (
          <div style={{
            background: alert.type === "success" ? "#d1fae5" : "#fee2e2",
            color: alert.type === "success" ? "#065f46" : "#991b1b",
            borderRadius: 10,
            padding: "12px 16px",
            marginBottom: 18,
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontWeight: 500,
            width: "100%"
          }}>
            {alert.type === "success" ? <CheckCircle size={18} /> : <XCircle size={18} />}
            <span>{alert.message}</span>
          </div>
        )}
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 18, width: "100%" }}>
          <div>
            <label style={{ fontWeight: 600, color: "#374151", marginBottom: 6, display: "block", fontSize: 14 }}>Email</label>
            <div style={{ position: "relative" }}>
              <Mail size={18} color="#64748b" style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)" }} />
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                placeholder="tu@email.com"
                style={{
                  width: "100%",
                  padding: "14px 14px 14px 44px",
                  border: "2px solid #f1f5f9",
                  borderRadius: 12,
                  fontSize: 15,
                  background: "#fafafa",
                  outline: "none",
                  fontFamily: "inherit",
                  boxSizing: "border-box"
                }}
                onFocus={e => { e.target.style.borderColor = "#3b82f6"; e.target.style.background = "white"; }}
                onBlur={e => { e.target.style.borderColor = "#f1f5f9"; e.target.style.background = "#fafafa"; }}
              />
            </div>
          </div>
          <div>
            <label style={{ fontWeight: 600, color: "#374151", marginBottom: 6, display: "block", fontSize: 14 }}>Nueva contraseña</label>
            <div style={{ position: "relative" }}>
              <Lock size={18} color="#64748b" style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)" }} />
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={form.password}
                onChange={handleChange}
                required
                placeholder="Mínimo 6 caracteres"
                style={{
                  width: "100%",
                  padding: "14px 14px 14px 44px",
                  border: "2px solid #f1f5f9",
                  borderRadius: 12,
                  fontSize: 15,
                  background: "#fafafa",
                  outline: "none",
                  fontFamily: "inherit",
                  boxSizing: "border-box"
                }}
                onFocus={e => { e.target.style.borderColor = "#3b82f6"; e.target.style.background = "white"; }}
                onBlur={e => { e.target.style.borderColor = "#f1f5f9"; e.target.style.background = "#fafafa"; }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#64748b",
                  padding: 4
                }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <div>
            <label style={{ fontWeight: 600, color: "#374151", marginBottom: 6, display: "block", fontSize: 14 }}>Confirmar contraseña</label>
            <div style={{ position: "relative" }}>
              <Lock size={18} color="#64748b" style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)" }} />
              <input
                type={showPassword ? "text" : "password"}
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                required
                placeholder="Repite la contraseña"
                style={{
                  width: "100%",
                  padding: "14px 14px 14px 44px",
                  border: "2px solid #f1f5f9",
                  borderRadius: 12,
                  fontSize: 15,
                  background: "#fafafa",
                  outline: "none",
                  fontFamily: "inherit",
                  boxSizing: "border-box"
                }}
                onFocus={e => { e.target.style.borderColor = "#3b82f6"; e.target.style.background = "white"; }}
                onBlur={e => { e.target.style.borderColor = "#f1f5f9"; e.target.style.background = "#fafafa"; }}
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: "14px 0",
              background: loading ? "#94a3b8" : "#1a1a1a",
              color: "white",
              border: "none",
              borderRadius: 12,
              fontSize: 16,
              fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: loading ? "none" : "0 4px 14px 0 rgba(26,26,26,0.18)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              fontFamily: "inherit",
              width: "100%"
            }}
          >
            {loading && <Loader2 size={18} className="animate-spin" />}
            {loading ? "Creando contraseña..." : "Crear contraseña"}
          </button>
          <button
            type="button"
            onClick={() => window.location.href = "/login"}
            style={{
              marginTop: 8,
              background: "transparent",
              border: "none",
              color: "#3b82f6",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
              textDecoration: "none",
              transition: "all 0.2s ease",
              fontFamily: "inherit",
              letterSpacing: "-0.01em",
              display: "flex",
              alignItems: "center",
              gap: 6,
              width: "100%",
              justifyContent: "center"
            }}
            onMouseEnter={e => { e.target.style.color = "#1d4ed8"; e.target.style.textDecoration = "underline"; }}
            onMouseLeave={e => { e.target.style.color = "#3b82f6"; e.target.style.textDecoration = "none"; }}
          >
            <ArrowLeft size={16} /> Volver al login
          </button>
        </form>
      </div>
    </div>
  );
};

export default PrimerLoginEmpleado; 